import styled from "styled-components";
import { colors, devicesNovo } from "../../utils/styled/_variables.styled";
import { StyleForm } from "./FormSimulation.types";

export const FormSimulationContainer = styled.div<StyleForm>`
  background-color: ${(props: { $backgroundColor: string }) =>
      props.$backgroundColor};
  border-radius: 16px;
  border-width: 1px;
  gap: 20px;
  padding: 40px 24px;
  border: ${(props: { isInModal?: boolean }) =>
      props.isInModal ? "" : "1px solid #999E9C" }  ;

  @media ${devicesNovo.smallDesktop} {
    border-radius: 12px;
    border-width: 1px;
    padding: 24px;
    gap: 40px;
  }

  .style-input{
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media ${devicesNovo.smallDesktop} {
      flex-direction: row;
      gap: 0px;
    }

    div:nth-child(1){
      width: 100%;
      margin-right: 20px;
    }
    div:nth-child(2){
      width: 100%;
    }
  }

  input{
    color: ${(props: { $textInputColor: string }) =>
      props.$textInputColor};
    background-color: ${(props: { $backgroundInputColor: string }) =>
      props.$backgroundInputColor};

    &::placeholder {
      color: ${(props: { $placeholderColor: string }) =>
        props.$placeholderColor};
    }
  }
  select{
    color: ${(props: { $textInputColor: string }) =>
      props.$textInputColor};
    background-color: ${(props: { $backgroundInputColor: string }) =>
      props.$backgroundInputColor};
  }
  option{
    color: ${(props: { $textInputColor: string }) =>
      props.$textInputColor};
    background-color: ${(props: { $backgroundInputColor: string }) =>
      props.$backgroundInputColor};
  }
  label{
    color: ${(props: { $labelColor: string }) =>
      props.$labelColor};
  }
 

  .title-form{
    color: ${(props: { $titleColor: string }) =>
    props.$titleColor};
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    line-height: 150%;
    letter-spacing: 0%;

    @media ${devicesNovo.smallDesktop} {
      font-size: 32px;
      line-height: 110.00000000000001%;
      letter-spacing: 0%;
    }
  }

  .subtitle-form{
    color: ${(props: { $subTitleColor: string }) =>
    props.$subTitleColor};
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 175%;
    letter-spacing: 0%;
    margin-bottom: 20px;

    @media ${devicesNovo.smallDesktop} {
      font-size: 18px;
      margin-bottom: 40px;
    }
  }
  .style-check{
    margin-top: 20px;
    p{
    color: ${(props: { $labelColor: string }) =>
      props.$labelColor} !important;
  }
    @media ${devicesNovo.smallDesktop} {
      margin-bottom: 20px;
    }
  }

  .kEfEgE {
    display: flex;
    gap: 8px;
    align-items: flex-start;
  }
  #politica-form{
    margin-top: 5px;
  }

  .modal__out {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999;

    div:nth-child(1){
      width: 90%;
      max-width: 260px;
      height: 150px;
      border-radius: 16px;
      opacity: 1;
      padding: 20px;
      gap: 8px;
      position: relative;
      overflow-y: auto;
      background-color: white;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

      @media (min-width: 768px) {
        max-width: 276px;
        width: 276px;
      }

      .modal__header{
        display: none !important;
      }

      h2{
        font-weight: 700;
        font-size: 18px;
        line-height: 150%;
        letter-spacing: 0px;
        text-align: center;
      }
    }
  }
  

`;


export const Form = styled.form`
  display: flex;
  gap: 20px;
  flex-direction: column;
`;

export const RecaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;

  iframe {
    border: none;
  }
`;

export const ButtonDefault = styled.button<{color?: string, backgroundColor?: string}>`
  display: flex;
  width: 100%;
  height: 48px;
  cursor: pointer;
  padding: 12px 24px;
  border-radius: 8px;
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor : colors.greenLight};
  color: ${(props) => props.color ? props.color : colors.white};
  text-decoration: none;
  justify-content: center;
  align-items: center;
  border: none;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  &:hover {
    background-color: ${(props) => props.backgroundColor ? props.backgroundColor : colors.greenDark};
  }

  &:disabled {
    background-color: ${colors.gray3};
    color: ${colors.gray4};
  }

  @media ${devicesNovo.smallDesktop} {
    max-width: 360px;
    align-self: center;
  }
`;